export default "/images/ManelCarrasco.jpg?d2665d47f3cf9b1210807dcfe3e14742";